"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return NocoCache;
    }
});
const _RedisCacheMgr = /*#__PURE__*/ _interop_require_default(require("./RedisCacheMgr"));
const _RedisMockCacheMgr = /*#__PURE__*/ _interop_require_default(require("./RedisMockCacheMgr"));
const _globals = require("~/utils/globals");
const _redisHelpers = require("~/helpers/redisHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function cacheContext(context) {
    if (context === 'root') {
        return `root`;
    }
    return `${context.workspace_id || 'nc'}:${context.base_id || 'nc'}`;
}
let NocoCache = class NocoCache {
    static init() {
        this.cacheDisabled = (process.env.NC_DISABLE_CACHE || false) === 'true';
        if (this.cacheDisabled) {
            return;
        }
        if ((0, _redisHelpers.getRedisURL)()) {
            this.client = new _RedisCacheMgr.default((0, _redisHelpers.getRedisURL)());
        } else {
            this.client = new _RedisMockCacheMgr.default();
        }
        // TODO(cache): fetch orgs once it's implemented
        const orgs = 'noco';
        this.prefix = `${_globals.CACHE_PREFIX}:${orgs}`;
    }
    static disableCache() {
        this.cacheDisabled = true;
    }
    static enableCache() {
        // return to default value
        this.cacheDisabled = (process.env.NC_DISABLE_CACHE || false) === 'true';
    }
    static async set(context, key, value) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.set(`${this.prefix}:${cacheContext(context)}:${key}`, value);
    }
    static async setExpiring(context, key, value, expireSeconds) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.setExpiring(`${this.prefix}:${cacheContext(context)}:${key}`, value, expireSeconds);
    }
    static async incrby(context, key, value) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.incrby(`${this.prefix}:${cacheContext(context)}:${key}`, value);
    }
    static async get(context, key, type) {
        if (this.cacheDisabled) {
            if (type === _globals.CacheGetType.TYPE_ARRAY) return Promise.resolve([]);
            else if (type === _globals.CacheGetType.TYPE_OBJECT) return Promise.resolve(null);
            return Promise.resolve(null);
        }
        return this.client.get(`${this.prefix}:${cacheContext(context)}:${key}`, type);
    }
    static async del(context, key) {
        if (this.cacheDisabled) return Promise.resolve(true);
        if (Array.isArray(key)) return this.client.del(key.map((k)=>`${this.prefix}:${cacheContext(context)}:${k}`));
        return this.client.del(`${this.prefix}:${cacheContext(context)}:${key}`);
    }
    static async getList(context, scope, subKeys, orderBy) {
        if (this.cacheDisabled) return Promise.resolve({
            list: [],
            isNoneList: false
        });
        return this.client.getList(`${this.prefix}:${cacheContext(context)}:${scope}`, subKeys, orderBy);
    }
    static async setList(context, scope, subListKeys, list, props = []) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.setList(`${this.prefix}:${cacheContext(context)}:${scope}`, subListKeys, list, props);
    }
    static async deepDel(context, key, direction) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.deepDel(`${this.prefix}:${cacheContext(context)}:${key}`, direction);
    }
    static async appendToList(context, scope, subListKeys, key) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.appendToList(`${this.prefix}:${cacheContext(context)}:${scope}`, subListKeys, `${this.prefix}:${cacheContext(context)}:${key}`);
    }
    static async update(context, key, updateObj) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.update(`${this.prefix}:${cacheContext(context)}:${key}`, updateObj);
    }
    static async setHash(context, key, hash, options = {}) {
        if (this.cacheDisabled) return Promise.resolve(true);
        if (Object.keys(hash).length === 0) {
            return;
        }
        return !!this.client.setHash(`${this.prefix}:${cacheContext(context)}:${key}`, hash, options);
    }
    static async getHash(context, key) {
        if (this.cacheDisabled) return Promise.resolve({});
        return this.client.getHash(`${this.prefix}:${cacheContext(context)}:${key}`);
    }
    static async getHashField(context, key, field) {
        if (this.cacheDisabled) return Promise.resolve(null);
        return this.client.getHashField(`${this.prefix}:${cacheContext(context)}:${key}`, field);
    }
    static async setHashField(context, key, field, value) {
        if (this.cacheDisabled) return Promise.resolve(true);
        return !!this.client.setHashField(`${this.prefix}:${cacheContext(context)}:${key}`, field, value);
    }
    static async incrHashField(context, key, field, value) {
        if (this.cacheDisabled) return Promise.resolve(0);
        return this.client.incrHashField(`${this.prefix}:${cacheContext(context)}:${key}`, field, value);
    }
    static async keyExists(context, key) {
        if (this.cacheDisabled) return Promise.resolve(false);
        return this.client.keyExists(`${this.prefix}:${cacheContext(context)}:${key}`);
    }
    static async processPattern(context, pattern, callback, options = {}) {
        if (this.cacheDisabled) return Promise.resolve();
        return this.client.processPattern(`${this.prefix}:${cacheContext(context)}:${pattern}`, callback, options);
    }
    static async clear(context) {
        if (this.cacheDisabled) return Promise.resolve();
        return this.client.processPattern(`${this.prefix}:${cacheContext(context)}:*`, async (keys)=>{
            await this.client.del(keys);
        }, {
            count: 100,
            batch: true,
            raw: true
        });
    }
    static async destroy() {
        if (this.cacheDisabled) return Promise.resolve(true);
        return this.client.destroy();
    }
    static async export() {
        if (this.cacheDisabled) return Promise.resolve({});
        return this.client.export();
    }
};
